import script from "./SalesmanCustomerManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesmanCustomerManagement.vue?vue&type=script&setup=true&lang=js"

import "./SalesmanCustomerManagement.vue?vue&type=style&index=0&id=def758b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-def758b4"]])

export default __exports__